import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

import { convertToOption } from '../../../util'

// Constants
export const constants = {
  GET_ALL_ITEMS: createSagaAction('GET_ALL_ITEMS'),
  CREATE_NEW_ITEM: createSagaAction('CREATE_NEW_ITEM'),
  UPDATE_SAVED_ITEM: createSagaAction('UPDATE_SAVED_ITEM')
}

// Action Creators
export const actions = {
  getAllItems: () => ({
    type: constants.GET_ALL_ITEMS.ACTION
  }),
  createNewItem: ({ item, userId }) => ({
    type: constants.CREATE_NEW_ITEM.ACTION,
    item,
    userId
  }),
  updateSavedItem: ({ item, itemId, userId }) => ({
    type: constants.UPDATE_SAVED_ITEM.ACTION,
    item,
    itemId,
    userId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_ALL_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_ITEMS.SUCCESS:
      return {
        ...state,
        loading: false,
        allItems: action.payload,
        allItemsForTypeahead: convertToOption(action.payload.data)
      }
    case constants.CREATE_NEW_ITEM.SUCCESS:
      return { ...state }
    case constants.UPDATE_SAVED_ITEM.SUCCESS:
      return { ...state }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/itemActions.js